import {useState} from 'react'

import PropTypes from 'prop-types'

import FilterWrapperBasicSearchBar from './SearchBar/index.js'
import FilterWrapperBasicFilter from './Filter.js'

const FilterWrapperBasicContent = ({
  filters,
  isFullWidth,
  group,
  onBlur,
  onChange,
  onFocus,
  value,
  withDivider,
  withLabel,
  withSearchBar
}) => {
  const [inputSearch, setInputSearch] = useState('')

  return (
    <>
      {withSearchBar && <FilterWrapperBasicSearchBar onSearch={setInputSearch} />}
      {filters.map(
        ({
          allSelectionsId,
          allSelectionsImageSrc,
          allSelectionsLabel,
          chips,
          description,
          design,
          id,
          label,
          name,
          options,
          nodeLabel,
          placeholder,
          suffix,
          suffixIcon,
          type,
          showLabel
        }) => (
          <FilterWrapperBasicFilter
            allSelectionsId={allSelectionsId}
            allSelectionsImageSrc={allSelectionsImageSrc}
            allSelectionsLabel={allSelectionsLabel}
            chips={chips}
            description={description}
            design={design}
            isFullWidth={isFullWidth}
            group={group}
            id={id}
            nodeLabel={nodeLabel}
            inputSearch={inputSearch}
            key={id}
            label={label}
            name={name}
            onBlur={onBlur}
            onChange={onChange}
            onFocus={onFocus}
            options={options}
            placeholder={placeholder}
            showLabel={showLabel}
            suffix={suffix}
            suffixIcon={suffixIcon}
            type={type}
            value={value[name]}
            withDivider={withDivider}
            withLabel={withLabel}
          />
        )
      )}
    </>
  )
}

FilterWrapperBasicContent.displayName = 'FilterWrapperBasicContent'
FilterWrapperBasicContent.propTypes = {
  filters: PropTypes.arrayOf(
    PropTypes.shape({
      allSelectionsId: PropTypes.string,
      allSelectionsImageSrc: PropTypes.string,
      allSelectionsLabel: PropTypes.string,
      description: PropTypes.string,
      group: PropTypes.string,
      id: PropTypes.array,
      label: PropTypes.string,
      name: PropTypes.string,
      onChange: PropTypes.func,
      options: PropTypes.arrayOf(
        PropTypes.shape({
          extendedInfo: PropTypes.string,
          icon: PropTypes.node,
          id: PropTypes.string,
          isHighlighted: PropTypes.bool,
          label: PropTypes.string,
          nestedItems: PropTypes.arrayOf(
            PropTypes.shape({
              extendedInfo: PropTypes.string,
              icon: PropTypes.node,
              id: PropTypes.string,
              isHighlighted: PropTypes.bool,
              label: PropTypes.string
            })
          )
        })
      ),
      placeholder: PropTypes.string,
      type: PropTypes.string,
      value: PropTypes.object
    })
  ),
  isFullWidth: PropTypes.bool,
  group: PropTypes.string,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  value: PropTypes.object,
  withDivider: PropTypes.bool,
  withLabel: PropTypes.bool,
  withSearchBar: PropTypes.bool
}

export default FilterWrapperBasicContent
